import { css } from 'styled-components';

export const minHeightWhenNoContent = css`
  &:after {
    content: '\u00A0';
    display: inline;
  }
`;
